<template>
    <li class="list-group-item">
        <div class="pull-right">
            <button class="btn btn-xs btn-default" @click="showEditDialog = true">
                <span class="fa fa-pencil"></span>
                Edit
            </button>
        </div>

        <strong>{{ orderItem.quantity }}</strong>

        <template v-if="showVendor">
            with
            <strong>{{ vendor && vendor.name }}</strong>,
        </template>

        added by
        <strong v-if="orderItem.user">
            {{ orderItem.user.full_name }}
        </strong>

        <div v-if="orderItem.notes" class="nl2br">{{ orderItem.notes }}</div>

        <OrderItemDialog
            v-if="showEditDialog"
            :orderItemId="orderItem.id"
            @hide="showEditDialog = false"
            @saved="showEditDialog = false"
            />
    </li>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        orderItem: null,
        showVendor: Boolean,
    },
    beforeCreate() {
        this.$options.components.OrderItemDialog = require('./OrderItemDialog');
    },
    data() {
        return {
            showEditDialog: false,
        };
    },
    computed: {
        ...mapState('data', {
            vendor(state) {
                return this.orderItem
                    && state.orders.byId[this.orderItem.order_id]
                    && state.vendors.byId[state.orders.byId[this.orderItem.order_id].vendor_id];
            },
        }),
    },
};
</script>
